export default "__VITE_ASSET__DsyWfNsN__"